import type { ReactNode } from 'react'

interface CtaBannerProps {
  title: string
  action: ReactNode
  variant?: 'brand' | 'dark' | 'featured'
}

export function CtaBanner({ title, action, variant = 'featured' }: CtaBannerProps) {
  if (variant === 'brand') {
    return (
      <section className="py-14 md:py-20 bg-brand">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-white max-w-2xl">
              {title}
            </h2>
            <div className="flex-shrink-0">{action}</div>
          </div>
        </div>
      </section>
    )
  }

  const isDark = variant === 'dark'

  return (
    <section className={`relative overflow-hidden py-16 md:py-24 ${isDark ? 'bg-heading' : 'bg-heading'}`}>
      <div className="absolute inset-0 opacity-10" aria-hidden="true">
        <div className="absolute -top-1/2 -left-1/4 w-[150%] h-[200%] rotate-12 bg-[repeating-linear-gradient(45deg,transparent,transparent_20px,rgba(255,255,255,0.03)_20px,rgba(255,255,255,0.03)_40px)]" />
      </div>
      <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand md:hidden" aria-hidden="true" />
      <div
        className="absolute top-0 left-0 h-full w-1/3 bg-brand hidden md:block"
        aria-hidden="true"
        style={{ clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0 100%)' }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
          <div className="max-w-2xl">
            <h2 className="font-display text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-white leading-tight">
              {title}
            </h2>
          </div>
          <div className="flex-shrink-0">{action}</div>
        </div>
      </div>
    </section>
  )
}
